import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-standard-job-templates-template',
  templateUrl: './standard-job-templates-template.component.html',
  styleUrls: ['./standard-job-templates-template.component.scss'],
  standalone: false,
})
export class StandardJobTemplatesTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;
}
